import { useTranslation } from "react-i18next";
const InfoInput = (props) => {
    const { t } = useTranslation()

    return (

        <div class="mb-3">
            <label for="correctAnswer" class="form-label"><b>{t("correctAnswer")}</b></label><br /><i>{props.text} </i>
            <textarea class="form-control" id="correctAnswer" rows="1" required />
        </div>
    );
};

export default InfoInput;